import { Navigate } from "react-router";
import { useGetCordwoodQuery } from "../../../apis/Cordwood.api";
import { PrimaryCordwood, Cordwood } from "../../../types/models/Cordwood";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const CordwoodScoped = () => {
    const {
        data,
    } = useGetCordwoodQuery(PrimaryCordwood.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/cordwoods/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default CordwoodScoped;
